import React from "react";
import Transmittal from "../../components/DocumentWorkflow/Transmittal/Transmittal.js";

const Transmittal_View = () => {
  return (
    <div>
      <Transmittal />
    </div>
  );
};

export default Transmittal_View;
